import React from 'react'
import Link from 'gatsby-link'
import Button from '../components/Button'
import Card from '../components/Card'
import Container from '../components/Container'
import SocialMedia from '../components/SocialMedia'

import logoCoderCatchup from "../images/logo-codercatchup.png";
import logoPixelstack from "../images/logo-pixelstack.png";
import logoCopirite from "../images/logo-copirite.png";
import logoDrupal from "../images/logo-drupal.png";
import logoHanami from "../images/logo-hanami.png";
import logoiOnline from "../images/logo-ionline.png";
import logoEasil from "../images/logo-easil.png";
import logoFoundation from "../images/logo-foundation.png";
import logoRails from "../images/logo-rails.png";
import logoXtreme from "../images/logo-xtreme.png";

const IndexPage = () => (
  <div>
    <header className="header-grid">
      <div className="header-grid__introduction">
        <div className="header-grid-introduction__main">
          <h1>My name is Jaymie Jones</h1>
          <p>I love to create things with software and hardware, whether that be websites, web applications, podcasts, videos or photos.</p>
        </div>
        <div className="header-grid-introduction__social">
          <SocialMedia />
        </div>
      </div>
      <div className="header-grid__me"></div>
    </header>
    <section className="coder-catchup">
      <Container>
        <div className="container__feature">
          <img src={logoCoderCatchup} alt="Coder Catchup" />
        </div>
        <div className="container__content">
          <h1>Coder Catchup Podcast<br />& YouTube Channel</h1>
          <p>Weekly podcast featuring news, reviews, tips and more. The YouTube channel features the podcast, software reviews, demos and much more.</p>
          <div className="button-group">
            <Button label='Listen' type='a' link='http://codercatchup.com' /> <Button label='Watch' type='a' link='https://youtube.com/codercatchup' />
          </div>
        </div>
      </Container>
    </section>
    <section className="pixelstack">
      <Container>
        <div className="container__feature">
          <img src={logoPixelstack} alt="Pixelstack" />
        </div>
        <div className="container__content">
          <h1>Design/Development Business</h1>
          <p>Pixelstack has been providing various online solutions since 2004 (formerly known as Triverse Designs) which has collaborated with various levels of clients, ranging from individuals, through to government.</p>
          <div className="button-group">
            <Button label='Find Out More' type='a' link='https://pixelstack.com' />
          </div>
        </div>
      </Container>
    </section>
    <section className="photography">
      <Container>
        <div className="container__content">
          <h1>Photography</h1>
          <p>Dabbling in some photography, capturing moments in various subjects.</p>
          <div className="button-group">
            <Button label='View' type='a' link='https://500px.com/jaymiejones86' />
          </div>
        </div>
      </Container>
    </section>
    <section className="work-history">
      <Container>
        <div className="container__content container__content--header">
          <h1>Work History</h1>
        </div>
        <div className="container__content">
          <div className="card-list">
            <Card title='Easil' date='April 2015 - Present' thumbnail={logoEasil}>
              <p>Role: Developer, API development with Ruby, front-end development with React.
      Responsibilities: Develop and maintain API and front-end, custom subscription system,
      custom ordering system.</p>
            </Card>
            <Card title='Copirite' date='July 2013 - Present' thumbnail={logoCopirite}>
              <p>Role: Developer
Responsibilities: front-end and back-end development for Rails applications and WordPress websites. General support, quoting and liaising with clients, maintaining and building features for in house management software.
Highlights: Macca Award win for Oscar Oscar Salons website, custom quoting system, conversion of MYOB to Xero online accounting.</p>
            </Card>
            <Card title='Pixelstack' date='January 2004 - Present' thumbnail={logoPixelstack}>
              <p>Role: Owner/Developer
Responsibilities: Overall running of the business, quoting, design, development, maintenance</p>
            </Card>
            <Card title='iOnline' date='July 2011 - 2013' thumbnail={logoiOnline}>
              <p>Role: Developer
Responsibilities: Build front-end requirements and integrate with a custom CMS. Back-end development of custom CMS.
Highlights: Development lead on xocashflow, a Xero partner integration to follow up bad debtors. ElevationHQ a custom build CRM SaaS application.</p>
            </Card>
            <Card title='Xtreme' date='June 2008 - July 2011' thumbnail={logoXtreme}>
              <p>Role: Web Designer
Responsibilities: Create custom CMS with Drupal, including design and implementation of custom design into theme. General maintenance of websites, quoting, eBrochures, EDMs, hosting support.</p>
            </Card>
          </div>
        </div>
      </Container>
    </section>
    <section className="work-history">
      <Container>
        <div className="container__content container__content--header">
          <h1>Software &amp; Skills</h1>
        </div>
        <div className="container__content">
          <div className="card-list">
            <Card title='Ruby' date='Experience: 6 years'>
              <p>Developing <a href='https://www.ruby-lang.org/'>ruby</a> apps for over 6 years, primarily with <a href='https://rubyonrails.org/'>Ruby on Rails</a> but also with other frameworks such as <a href='http://sinatrarb.com/'>Sinatra</a> and <a href='https://hanamirb.org/'>Hanami</a>.</p>
              <p>This also included plain old ruby for non-web tasks or <a href='https://rubygems.org/'>ruby gem</a> development</p>
            </Card>
            <Card title='Javascript' date='Experience: 14 Years'>
              <p>Programming with Javascript for quite some time but only in the past 6 - 8 years that I have taken Javascript more seriously.</p>
              <p>Primarily developing within frameworks and libraries such as <a href='https://reactjs.org/'>React</a>, <a href='https://angular.io/'>Angular</a> and <a href='https://jquery.com/'>jQuery</a>.</p>
            </Card>
            <Card title='PHP' date='Experience: 14 Years'>
              <p>I have been developing with <a href='http://www.php.net/'>PHP</a> for most of my career, working with custom CMS development, <a href='https://www.drupal.org/'>Drupal</a>, <a href='https://wordpress.org/'>WordPress</a>, <a href='https://www.joomla.org/'>Joomla</a>, <a href='https://magento.com/'>Magento</a>, <a href='https://www.codeigniter.com/'>Codeigniter</a> and some <a href='https://laravel.com/'>Laravel</a>.</p>
              <p>Most of my PHP development has been in Drupal and WordPress as well as some in-house CMS</p>
            </Card>
            <Card title='SQL (Postgres, MySQL)' date='Experience: 14 Years'>
              <p>I have been developing websites and applications with SQL since the beginning, starting off with <a href='https://www.mysql.com/'>MySQL</a>.</p>
              <p>I eventually moved from writing raw SQL to using an abstraction library such as ActiveRecord for quite some time, which was when I also switched to mostly using <a href='https://www.postgresql.org/'>Postgres</a>.</p>
              <p>At the moment I am developing more applications with raw SQL again</p>
            </Card>
            <Card title='CSS Frameworks' date='Various CSS Frameworks, Less, Sass and Plain CSS Based'>
              <p>Developing websites and web applications with various CSS Frameworks such as <a href='https://getbootstrap.com/'>Bootstrap</a>, <a href='https://foundation.zurb.com/'>Foundation</a>, <a href='https://www.bourbon.io/'>Bourbon</a>, <a href='https://neat.bourbon.io/'>Neat</a>.</p>
            </Card>
            <Card title='React' date='Experience: 3 Years'>
              <p>Developed websites and web applications with React, this involved entire applications as React as well as dropping in React into server side rendered applications.</p>
            </Card>
            <Card title='Elixir' date='Experience: 2 Years Experimenting'>
              <p>I have taken an interest in Elixir over the past 2 years writing sample applications and exploring the ecosystem with plain <a href='https://elixir-lang.org/'>elixir</a> and work with <a href='https://phoenixframework.org/'>Phoenix</a>.</p>
              <p>This does not include any production application development and has only been experimented with in small allocations of time.</p>
            </Card>
            <Card title='Git' date='Experience: 9 Years'>
              <p>Using <a href='https://git-scm.com/'>git</a> in my day to day workflows for the past 9 years (previously using SVN).</p>
            </Card>
            <Card title='Docker' date='Experience: 3 Years'>
              <p>Working to a minor capacity with <a href='https://www.docker.com/'>docker</a>, using standard docker as well as docker via docker compose to run local application development.</p>
            </Card>
            <Card title='Server Management' date='Experience: 10 Years'>
              <p>General server provisioning and maintenance of linux based servers.</p>
              <p>This has included setting up servers for new websites and applications manually and using some automation such as <a href='https://www.chef.io/'>Chef</a> and <a href='https://www.ansible.com/'>Ansible</a>.</p>
              <p>Using providers such as Digital Ocean, Linode, AWS, Rackspace and Mediatemple.</p>
            </Card>
            <Card title='Adobe Creative Suite' date='Experience: 14 Years'>
              <p>Using various applications from the now known Creative Cloud, Photoshop, Illustrator, Premier Pro being the primary applications.</p>
            </Card>
            <Card title='Sketch' date='Experience: 4 Years'>
              <p>My go to <a href='https://www.sketchapp.com/'>design tool/application</a> of choice.</p>
            </Card>
          </div>
        </div>
      </Container>
    </section>
    <section className="community-history">
      <Container>
        <div className="container__content container__content--header">
          <h1>Community</h1>
        </div>
        <div className="container__content">
          <div className="card-list">
            <Card title='Drupal Gold Coast' date='January 2011 - May 2017 (currently on a break)' thumbnail={logoDrupal}>
              <p>Role: Co-founder and host
Responsibilities: Organising and speaking</p>
            </Card>
            <Card title='Ruby on Rails Gold Coast' date='September 2012 - September 2015' thumbnail={logoRails}>
              <p>Role: Co-founder and host
Responsibilities: Organising and speaking</p>
            </Card>
          </div>
        </div>
      </Container>
    </section>
    <section className="work-history">
      <Container>
        <div className="container__content container__content--header">
          <h1>Open Source Contributions</h1>
        </div>
        <div className="container__content">
          <div className="card-list">
            <Card title='Foundation by Zurb' date='https://foundation.zurb.com/' thumbnail={logoFoundation}>
              <p>Contribution: Added Height Fix For Object and Embed Tags
PR: https://github.com/zurb/foundation-sites/pull/763</p>
            </Card>
            <Card title='Hanami Ruby Framework' date='http://hanamirb.org/' thumbnail={logoHanami}>
              <p>Contribution: Update Documentation
PR: https://github.com/hanami/utils/pull/215</p>
            </Card>
          </div>
        </div>
      </Container>
    </section>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js